import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import { withCustomValidation } from '@bingads-webui-react/validation';
import { ActivityContext } from '@bingads-webui-react/hoc-with-signal';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { LegacyAdSchedule } from './legacy-ad-schedule';

const LegacyAdScheduleWithCustomValidation = ({
  validationProps, updateValidation, ...restProps
}) => {
  const { data: adSchedules } = validationProps;

  const i18n = useContext(I18nContext);
  const activity = useContext(ActivityContext);

  const onChange = useCallback((newData, newIsValid, shouldDirty = true) => {
    updateValidation(newIsValid ? [] : [i18n.getString(_TL_('Ad schedule has validation errors'))], newData, shouldDirty);
    // onChange will triggered every time data changed. We only want to trace the manually change.
    // Please refer ./legacy-ad-schedule.js line: 150.
    if (activity && shouldDirty !== false) {
      activity.signal(`onLegacyAdScheduleChange - ${JSON.stringify(newData)}`);
    }
  }, [updateValidation, i18n, activity]);


  return (
    <LegacyAdSchedule
      onChange={onChange}
      data={adSchedules}
      activity={activity}
      {...restProps}
    />
  );
};

LegacyAdScheduleWithCustomValidation.propTypes = {
  validationProps: PropTypes.shape({
    data: PropTypes.shape({}),
  }).isRequired,
  updateValidation: PropTypes.func.isRequired,
  activity: PropTypes.shape({
    signal: PropTypes.func,
  }),
};

LegacyAdScheduleWithCustomValidation.defaultProps = {
  activity: null,
};

export const ValidatedLegacyAdSchedule = withCustomValidation(LegacyAdScheduleWithCustomValidation);
